import React from 'react'
import './Experience.css'
function Experience() {
  return (
 <div className="experience" id='Experience'>
    <div className="achievements">
        <div className="circle">
           X+ 
        </div>
        <span>years</span>
        <span>Experience</span>
    </div>
    <div className="achievements">
        <div className="circle">
           15+
        </div>
        <span>Completed</span>
        <span>Projects</span>
    </div>
    <div className="achievements">
        <div className="circle">
         1
        </div>
        <span>Companies</span>
        <span>Work</span>
    </div>
 </div>
  )
}

export default Experience